/**
 * Generated by orval 🍺
 * Do not edit manually.
 * FastAPI
 * OpenAPI spec version: 0.1.0
 */
import type { GradingStatsRow } from './gradingStatsRow';
import type { GradingStatsReportPagination } from './gradingStatsReportPagination';

/**
 * Grading statistics report payload.
 */
export interface GradingStatsReport {
  /** Unique ID of the report type */
  reportId?: string;
  /** When the report was generated */
  createdAt?: string;
  data?: GradingStatsRow[];
  pagination?: GradingStatsReportPagination;
}
